module.exports = __webpack_public_path__ + "assets/img/capabilities_img4.ada1f7d2.png";